import Component from "./View";

export type IProps = {
  cardBrandId: number;
  last4: string;
};

export default Component;
